import script from "./AdminUserQuestionsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminUserQuestionsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminUserQuestionsPage.vue?vue&type=style&index=0&id=be49a336&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be49a336"]])

export default __exports__